export const Consumables = [
    ['Bomb', JSON.stringify({
      id: '5',
      subtype: '40',
      variant: '1',
    })],
    ['Double Bomb', JSON.stringify({
      id: '5',
      subtype: '40',
      variant: '2',
    })],
    ['Golden Bomb', JSON.stringify({
      id: '5',
      subtype: '40',
      variant: '4',
    })],
    ['Giga Bomb', JSON.stringify({
      id: '5',
      subtype: '40',
      variant: '7',
    })],
    ['Key', JSON.stringify({
      id: '5',
      subtype: '30',
      variant: '1',
    })],
    ['Golden Key', JSON.stringify({
      id: '5',
      subtype: '30',
      variant: '2',
    })],
    ['Key Ring', JSON.stringify({
      id: '5',
      subtype: '30',
      variant: '3',
    })],
    ['Charged Key', JSON.stringify({
      id: '5',
      subtype: '30',
      variant: '4',
    })],
    ['Penny', JSON.stringify({
      id: '5',
      subtype: '20',
      variant: '1',
    })],
    ['Nickel', JSON.stringify({
      id: '5',
      subtype: '20',
      variant: '2',
    })],
    ['Dime', JSON.stringify({
      id: '5',
      subtype: '20',
      variant: '3',
    })],
    ['Double Penny', JSON.stringify({
      id: '5',
      subtype: '20',
      variant: '4',
    })],
    ['Lucky Penny', JSON.stringify({
      id: '5',
      subtype: '20',
      variant: '5',
    })],
    ['Sticky Nickel', JSON.stringify({
      id: '5',
      subtype: '20',
      variant: '6',
    })],
    ['Golden Penny', JSON.stringify({
      id: '5',
      subtype: '20',
      variant: '7',
    })],
    ['Full Heart', JSON.stringify({
        id: '5',
        subtype: '10',
        variant: '1',
    })],
    ['Half Heart', JSON.stringify({
        id: '5',
        subtype: '10',
        variant: '2',
    })],
    ['Soul Heart', JSON.stringify({
        id: '5',
        subtype: '10',
        variant: '3',
    })],
    ['Eternal Heart', JSON.stringify({
        id: '5',
        subtype: '10',
        variant: '4',
    })],
    ['Double Heart', JSON.stringify({
        id: '5',
        subtype: '10',
        variant: '5',
    })],
    ['Black Heart', JSON.stringify({
        id: '5',
        subtype: '10',
        variant: '6',
    })],
    ['Golden Heart', JSON.stringify({
        id: '5',
        subtype: '10',
        variant: '7',
    })],
    ['Half Soul Heart', JSON.stringify({
        id: '5',
        subtype: '10',
        variant: '8',
    })],
    ['Scared Heart', JSON.stringify({
        id: '5',
        subtype: '10',
        variant: '9',
    })],
    ['Blended Heart', JSON.stringify({
        id: '5',
        subtype: '10',
        variant: '10',
    })],
    ['Bone Heart', JSON.stringify({
        id: '5',
        subtype: '10',
        variant: '11',
    })],
    ['Rotten Heart', JSON.stringify({
        id: '5',
        subtype: '10',
        variant: '12',
    })],
  ]
  